<template>
    <div :class="[colClass]">
        <ChildrenList :children-ids="displayElementVmId" :view-only="true"></ChildrenList>
        <AdminSettingsDifferences :data="data" />
    </div>
</template>
<script lang="ts">
import { defineComponent, computed, provide, inject } from "vue";
import { usePageStore } from "../pageState/store";
import { props, Props, components, setup } from "./BaseDefMixin.3";
import type DisplayElementDef from "../elements/DisplayElementDef";
import { DisplayElementSetting } from "@cs-ts/display-element-setting";
import { useObservable } from "@vueuse/rxjs";
import { map } from "rxjs/operators";
import { BaseElementDefBase } from "../elements/BaseElementDef";
export default defineComponent({
    components: {
        ...components,
        //DatePicker,
    },
    props: props,
    //@ts-ignore
    setup(props: Props<DisplayElementDef, DisplayElementSetting>) {
        const base = setup<DisplayElementDef, DisplayElementSetting>(props);
        const pageStore = usePageStore();

        const mustMask = inject("mustMask", () => false);
        const reviewHiddenElements = inject("reviewHiddenElements", () => ({ elements: [], shouldProvide: true }));

        const displayElementVmId = useObservable(pageStore.getElementsById$(base.settings.value.elementId!, base.vmId.value).pipe(map(i => i!.map(j => j.vmId))));

        const maskedOutput = computed(() => mustMask() || base.settings.value.maskedOutput);
        const hiddenElements = computed(() => (reviewHiddenElements().shouldProvide ? reviewHiddenElements().elements : null!));

        provide("elementFilter", (el: BaseElementDefBase) => {
            return el.id != props.data.id && base.elementFilter(el);
        });
        provide("reviewHiddenElements", () => {
            return { elements: hiddenElements.value, shouldProvide: false };
        });
        provide("hiddenElements", () => hiddenElements.value);
        provide("mustMask", () => maskedOutput.value);

        return {
            displayElementVmId,

            ...base.expose,
        };
    },
});
</script>
